import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'

export const ProgramEpgItemSC = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-left: 14px;
  padding-bottom: 16px;

  &::before {
    content: '';
    position: absolute;
    top: 7px;
    left: -3px;
    height: 8px;
    width: 8px;
    background: var(${COLOR.ACCENT_PRIMARY_GRADIENT});
    border-radius: 50%;
  }
  &::after {
    content: '';
    position: absolute;
    top: 7px;
    left: 0px;
    height: 100%;
    width: 2px;
    background: var(${COLOR.ACCENT_PRIMARY_GRADIENT});
    opacity: 0.5;
  }

  &:last-of-type::after {
    height: calc(100% - 16px - 7px); //bottom padding && top offset
  }
`
